module.exports = __webpack_public_path__ + "img/listItem5.2bc3cfba.png";